import styled from "styled-components";

import { color } from "emoreg/const";

const Container = styled.button<{ selected?: boolean }>(
  {
    border: "none",
    margin: 0,
    paddingBlock: 4,
    paddingInline: 12,
    borderRadius: 4,
    cursor: "pointer",
    backgroundColor: "transparent",
    transition: "background-color 0.2s ease-in-out",
    "&:disabled": { opacity: 0.5, cursor: "not-allowed" },
    "&:not(:disabled):hover": { backgroundColor: color.grey.light },
  },
  ({ selected }) => ({
    color: selected ? color.blue.base : color.grey.darker,
  })
);

Container.baseName = "SelectOption.Container";

export const SelectOptionStyle = Container;
